(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupDeleteController',ReportGroupDeleteController);

    ReportGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReportGroup'];

    function ReportGroupDeleteController($uibModalInstance, entity, ReportGroup) {
        var vm = this;

        vm.reportGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReportGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
